
<div style="width: 100%; height: 100%; padding-left: 32px; padding-right: 32px; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
  <div data-style="Outlined" style=" position: relative; overflow: hidden">
    <mat-icon class="big-icon">people</mat-icon>
  </div>
  <div data-gutter-bottom="False" data-variant="h6" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
      <div style="align-self: stretch; color: rgba(0, 0, 0, 0.60); font-size: 20px; font-family: Roboto; font-weight: 500; line-height: 32px; letter-spacing: 0.15px; word-wrap: break-word">Users list</div>
  </div>
</div>
<div class="column">
    <div class="task--search-bar">
        <mat-form-field appearance="outline" class="search--input">
            <mat-label>Type user name to find</mat-label>
            <input matInput type="text" placeholder="Type user name to find" [(ngModel)]="query" (ngModelChange)="onSearch()">
            <button matSuffix mat-icon-button>
                <mat-icon>search</mat-icon>
              </button>
          </mat-form-field>
          <mat-form-field appearance="outline" class="status">
            <mat-label>Groups</mat-label>
            <mat-select [(ngModel)]="queryGroup" (ngModelChange)="onGroupFilter()">
              <mat-option value="all" class="all"><mat-icon [svgIcon]="icons.FilterOffIcon" />All</mat-option>
              @for (group of userGroups; track group) {
                <mat-option [value]="group.id">{{ group.groupName }}</mat-option>
                }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="status">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="queryStatus" (ngModelChange)="onStatusFilter()">
              <mat-select-trigger *ngIf="queryStatus && queryStatus !=='all'">
                <app-status-indicator [statusText]="queryStatus" [isDropdownOption]="true"></app-status-indicator>
              </mat-select-trigger>
              <mat-option value="all" class="all"><mat-icon [svgIcon]="icons.FilterOffIcon" />All</mat-option>
              <mat-option [value]="UserStatusEnum.Active"><app-status-indicator [statusText]="UserStatusEnum.Active"
                  [isDropdownOption]="true"></app-status-indicator></mat-option>
              <mat-option [value]="UserStatusEnum.Inactive"><app-status-indicator [statusText]="UserStatusEnum.Inactive"
                  [isDropdownOption]="true"></app-status-indicator></mat-option>
             
            </mat-select>
          </mat-form-field>

 
            <app-icon-detail [model]="this.userModel"></app-icon-detail>
            <button class="continue" (click)="addNewUser()" mat-button> <mat-icon [svgIcon]="icons.YesIcon"></mat-icon>
              Add User</button>
    </div>
    <div class="mat-elevation-z8">
      <table   mat-table matSort aria-label="Elements">

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
          <td mat-cell *matCellDef="let row">{{row.id}}</td>
        </ng-container>
    
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First name</th>
          <td mat-cell *matCellDef="let row">{{row.firstName}}</td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last name</th>
          <td mat-cell *matCellDef="let row">{{row.lastName}}</td>
        </ng-container>

        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email address</th>
          <td mat-cell *matCellDef="let row">{{row.userName}}</td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone number</th>
          <td mat-cell *matCellDef="let row">{{row.phoneNumber}}</td>
        </ng-container>


        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let row">
            <app-status-indicator [statusText]="mapstatus(row.status)"></app-status-indicator>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastLoginDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last login date</th>
          <td mat-cell *matCellDef="let row">{{ row.lastLoginDate | date:'MM/dd/yyyy h:mm a' }}</td>
        </ng-container>

      
        <ng-container matColumnDef="actions">
          <th style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element;let i=index;" (click)="$event.stopPropagation()">
            <button mat-icon-button class="row-actions-trigger"
                    [matMenuTriggerFor]="rowMenu"
                    [attr.aria-label]="'Actions for ' + element.userName"
                    matTooltip="Actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu">
              <button mat-menu-item (click)="editUser(element)">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-menu-item (click)="resetPassword(element)">
                <mat-icon>lock_reset</mat-icon>
                <span>Reset password</span>
              </button>
              <button mat-menu-item (click)="toggleStatus(element)">
                <mat-icon>{{ isActive(element) ? 'block' : 'check_circle' }}</mat-icon>
                <span>{{ isActive(element) ? 'Disable' : 'Enable' }}</span>
              </button>
              <button mat-menu-item (click)="impersonateUser(element)">
                <mat-icon>switch_account</mat-icon>
                <span>Impersonate</span>
              </button>
              <button mat-menu-item class="menu-item-danger" (click)="removeUser(element)">
                <mat-icon>delete_outline</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr  mat-row *matRowDef="let row; columns: displayedColumns;"
      (click)="editUser(row)" style="cursor: pointer;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No data matching the filter.
          </td>
        </tr>
      </table>
      <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
    </mat-paginator>
    </div>
</div>